export default __webpack_public_path__ + "static/media/unhcr-logo-blue.c439cb80.png";